import { useEffect, useRef } from "react";

type Options = {
  enabled: boolean;
  isSending: boolean;
  /** Hermes Cable 在 brand_site_write/delete 的 tool_result 后递增 */
  brandSiteDraftRevision: number;
  refresh: () => Promise<unknown>;
};

/**
 * 站页草稿预览刷新：不空闲轮询。
 * - 工具写/删页 → 立刻拉
 * - 本轮 Hermes 结束 → 再拉一次兜底
 */
export function useRefreshBrandSitePagesOnHermesDraft({
  enabled,
  isSending,
  brandSiteDraftRevision,
  refresh,
}: Options) {
  const wasSendingRef = useRef(false);

  useEffect(() => {
    if (!enabled || brandSiteDraftRevision < 1) return;
    void refresh().catch(() => undefined);
  }, [enabled, brandSiteDraftRevision, refresh]);

  useEffect(() => {
    if (!enabled) {
      wasSendingRef.current = isSending;
      return;
    }
    if (wasSendingRef.current && !isSending) {
      void refresh().catch(() => undefined);
    }
    wasSendingRef.current = isSending;
  }, [enabled, isSending, refresh]);
}
